import React from 'react';
import { Tooltip } from 'antd';

const StatusColors = ({ data }) => {
    return (
        <div style={{ display: "flex", flexDirection: "row", padding: "1px" }}>
            {
                data.map(element => {
                    return (
                        <Tooltip key={element.title} placement="top" title={element.title}>
                            <div style={{ backgroundColor: element.color, width: "12px", height: "12px", borderRadius: "50%", marginLeft: "4px" }}></div>
                        </Tooltip>
                    )
                })
            }
        </div>
    );
};

export default StatusColors;